<script>
import { BOverlay } from "bootstrap-vue";

export default {
  extends: BOverlay
};
</script>